import { experiences } from '../data/experiences';
import { generalFaqs } from '../data/faq';
import { ExperienceCard } from '../components/ExperienceCard';
import { Includes } from '../components/Includes';
import { Faq } from '../components/Faq';
import { useDocumentTitle } from '../lib/useDocumentTitle';
import { useBooking } from '../components/booking';

export function ExperiencesPage() {
  useDocumentTitle('Santorini Photoshoot Experiences | Flying Muse');
  const { openBooking } = useBooking();

  return (
    <div>
      {/* Hero */}
      <header className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img src="/img/hero.webp" alt="" aria-hidden="true" width={1920} height={1080} className="h-full w-full object-cover object-[68%_center]" />
          <div className="absolute inset-0 bg-gradient-to-r from-navy-deep/90 via-navy-deep/60 to-navy-deep/30" />
          <div className="absolute inset-0 bg-gradient-to-t from-navy-deep/70 via-transparent to-navy-deep/30" />
        </div>
        <div className="container-content section-pad relative z-10 pb-16 pt-32 sm:pb-20 sm:pt-40">
          <p className="eyebrow text-crimson-soft">Choose Your Moment</p>
          <h1 className="mt-4 max-w-2xl font-display text-[clamp(2.5rem,6vw,4.5rem)] font-medium leading-[1.04] text-white">
            The Experiences
          </h1>
          <p className="mt-6 max-w-xl font-sans text-base font-light leading-relaxed text-white/85">
            Private, editorial photoshoots above the Santorini caldera - from wind-caught flying
            dresses to relaxed lifestyle sessions, island tours and tailor-made love stories.
          </p>
        </div>
      </header>

      {/* Experience grid */}
      <section className="bg-cream py-20 sm:py-24" aria-label="All experiences">
        <div className="container-content section-pad">
          {/* Keeps the heading order sequential (h1 -> h2 -> card h3) without
              adding a visible section title above the grid. */}
          <h2 className="sr-only">All experiences</h2>
          <div className="grid gap-7 sm:grid-cols-2 lg:gap-8">
            {experiences.map((exp) => (
              <ExperienceCard key={exp.id} exp={exp} />
            ))}
          </div>
        </div>
      </section>

      {/* What every experience includes */}
      <Includes />

      {/* General FAQ */}
      <section className="bg-cream py-20 sm:py-24">
        <div className="container-content section-pad">
          <div className="text-center">
            <p className="eyebrow eyebrow--center">Good to Know</p>
            <h2 className="mt-4 font-display text-[clamp(2rem,4.5vw,3rem)] font-medium text-charcoal">
              Locations &amp; booking
            </h2>
          </div>

          <div className="mt-12 space-y-14">
            {generalFaqs.map((group) => (
              <div key={group.title}>
                <h3 className="mx-auto mb-6 max-w-3xl font-sans text-[0.65rem] font-semibold uppercase tracking-label text-crimson">
                  {group.title}
                </h3>
                <Faq items={group.items} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Closing CTA */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img src="/img/flying-dress.webp" alt="" aria-hidden="true" loading="lazy" width={1600} height={1067} className="h-full w-full object-cover object-[50%_30%]" />
          <div className="absolute inset-0 bg-gradient-to-r from-navy-deep/90 via-navy-deep/55 to-transparent" />
        </div>
        <div className="container-content section-pad relative z-10 py-20 sm:py-28">
          <div className="max-w-xl">
            <p className="eyebrow text-crimson-soft">Limited Dates Each Season</p>
            <h2 className="mt-5 font-display text-[clamp(2rem,5vw,3.5rem)] font-medium leading-[1.06] text-white">
              Your story, above the caldera.
            </h2>
            <button
              type="button"
              onClick={() => openBooking(undefined, undefined, 'experiences_page')}
              className="btn btn-primary mt-8"
            >
              Book Your Session
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
